import {useTranslation} from "react-i18next";
import question from '../../assets/images/icons/question.svg';
import ScorePrice from "../ScorePrice/ScorePrice";
import { v4 as uuidv4 } from 'uuid';

export default function DailyQuests({quests}) {
    const { t } = useTranslation();

    return (
        <>
            <h5>{t('surveys.inQuests')}</h5>
            {
                quests.map(quest =>
                    <a key={uuidv4()} className="daily-task-block flex" href={"/surveys/" + quest.completeConditions[0].parameters.id}>
                        <div className="icon-block">
                            <img src={question} alt="" />
                        </div>
                        <div>
                            <h6>{t('main.questCaptions.survey.header')} «{quest.completeConditions[0].parameters.name}»</h6>
                            <p>{t('main.questCaptions.survey.text')} «{quest.completeConditions[0].parameters.name}».</p>
                            <div className="score-block">
                                <div className="score-inline">
                                    { quest.prices.map(price => <ScorePrice key={uuidv4()} {...price} />) }
                                </div>
                            </div>
                        </div>
                    </a>
                )
            }
        </>
    )
}
